const model = {
    submitting: false,
    errors: null,
    details: null,
    success: false,
};

export default model;
